/**
 * Outreach attribution code (from a QR / mailer link such as
 * `/signup?outreach_ref=ABC123`) kept in sessionStorage so it survives the
 * round-trip through Google OAuth and the email verification step.
 */
export const OUTREACH_REF_STORAGE_KEY = 'outreach_ref';

const normalize = (code) => {
  const value = typeof code === 'string' ? code.trim().toUpperCase() : '';
  return value || null;
};

export const readStoredOutreachRef = () => {
  try {
    return normalize(window.sessionStorage.getItem(OUTREACH_REF_STORAGE_KEY));
  } catch (_) {
    return null;
  }
};

export const storeOutreachRef = (code) => {
  const value = normalize(code);
  if (!value) {
    return null;
  }
  try {
    window.sessionStorage.setItem(OUTREACH_REF_STORAGE_KEY, value);
  } catch (_) {
    /* sessionStorage unavailable; the in-memory copy still works for this page */
  }
  return value;
};

export const clearStoredOutreachRef = () => {
  try {
    window.sessionStorage.removeItem(OUTREACH_REF_STORAGE_KEY);
  } catch (_) {
    /* nothing to clear */
  }
};
